import { render, staticRenderFns } from "./SearchRow.vue?vue&type=template&id=620274cd&scoped=true"
import script from "./SearchRow.vue?vue&type=script&lang=js"
export * from "./SearchRow.vue?vue&type=script&lang=js"
import style0 from "./SearchRow.vue?vue&type=style&index=0&id=620274cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620274cd",
  null
  
)

export default component.exports